// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iP","loading":"iQ","b":"iR","errorMsg":"iS","loadingMsg":"iT","successMsg":"iU","hideLoadingMsg":"iV","completed":"iW","a":"iX","kidsGreen":"iY"};